var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection-placeholder-wrap"},[_c('div',{staticClass:"selection-placeholder__silk"}),_c('div',{staticClass:"selection-placeholder__main",style:(_vm.placeholderWidth)})])}
var staticRenderFns = []

export { render, staticRenderFns }